// Status + reason vocabularies shared across the reconciliation UI.

export const STATUS_META = {
  CONCILIADO: {
    label: "Conciliado",
    bg: "#D1FAE5", text: "#065F46", border: "#34D399",
  },
  PENDIENTE_STORIS: {
    label: "Pendiente en STORIS",
    bg: "#FEF3C7", text: "#92400E", border: "#FBBF24",
  },
  EXISTE_UI_NO_REPORTE: {
    label: "Solo en UI",
    bg: "#F1F5F9", text: "#475569", border: "#CBD5E1",
  },
  DIFERENCIA: {
    label: "Diferencia",
    bg: "#FEE2E2", text: "#991B1B", border: "#F87171",
  },
  DATOS_INCOMPLETOS: {
    label: "Datos incompletos",
    bg: "#FFEDD5", text: "#9A3412", border: "#FB923C",
  },
};

export const REASON_LABELS = {
  DIFERENCIA_FECHA: "Fecha",
  DIFERENCIA_ESTATUS: "Estatus",
  DIFERENCIA_CANTIDAD: "Cantidad",
  FALTA_ORDER_NUMBER: "Falta Order #",
  FALTA_MODEL_NUMBER: "Falta Modelo",
  FECHA_INVALIDA: "Fecha inválida",
};

export const DLVY_STATUS_LABELS = {
  PROGRAMADA: "Programada",
  CONTRA_ENTREGA: "Contra entrega (COD)",
  SIN_PROGRAMAR: "Sin programar",
  ESTIMADA: "Estimada",
  POR_CONFIRMAR: "Por confirmar (CWC)",
  URGENTE: "Urgente (ASAP)",
  ENTREGADA: "Entregada",
  CANCELADA: "Cancelada",
  EN_ESPERA: "En espera",
  PENDIENTE: "Pendiente",
};

export function statusMeta(code) {
  return STATUS_META[code] || { label: code, bg: "#F1F5F9", text: "#475569", border: "#CBD5E1" };
}

export function dlvyStatusLabel(code) {
  if (!code) return "—";
  return DLVY_STATUS_LABELS[code] || code;
}

// Best-effort map: STORIS truck route code prefix -> Canales store/owner.
// (Route codes carry a trailing "D" for Delivery, e.g. FBGSD -> F.B.G.S Corp.)
export const ROUTE_STORE = {
  FBGS: { store: "Garland · Mesquite · Oak Cliff", owner: "Francisco Torres", corp: "F.B.G.S Corp" },
  HOLG: { store: "Waxahachie · Weatherford", owner: "Holguin", corp: "Holguin LLC" },
  JEVC: { store: "Rockwall · Terrell", owner: "Yenice Villeda", corp: "JEVC LLC" },
  SCMG: { store: "Arlington", owner: "Selene Martinez", corp: "SCMG Corp" },
  JMGT: { store: "North Dallas · Plano", owner: "Juan Gutierrez", corp: "JMGTZ Corp" },
  LARI: { store: "Harry Hines", owner: "Juan Rodriguez", corp: "Larios Design Corp" },
  DUNC: { store: "Duncanville", owner: "Marlen Lopez", corp: "C E Lopez Corp" },
  WACO: { store: "Waco", owner: "Alexander Ambriz", corp: "NRAD Corp" },
  OKC: { store: "Oklahoma City", owner: "Sara Cavanzo", corp: "JM Cavanzo Corp" },
  REYN: { store: "Fort Worth", owner: "Yolanda Canales", corp: "Reyna & Canales Corp" },
};

export function storeForRoute(route) {
  if (!route) return null;
  const up = String(route).toUpperCase();
  const key = Object.keys(ROUTE_STORE).find((k) => up.startsWith(k));
  return key ? ROUTE_STORE[key] : null;
}

export const SLA_META = {
  FUERA_SLA: { label: "Fuera de SLA", bg: "#FEE2E2", text: "#991B1B", border: "#F87171" },
  EN_RIESGO: { label: "En riesgo", bg: "#FEF3C7", text: "#92400E", border: "#FBBF24" },
  EN_SLA: { label: "En SLA", bg: "#D1FAE5", text: "#065F46", border: "#34D399" },
};

export function slaMeta(code) {
  return SLA_META[code] || null;
}

export const SLA_FILTER_OPTIONS = [
  { value: "FUERA_SLA", label: "Fuera de SLA" },
  { value: "EN_RIESGO", label: "En riesgo" },
  { value: "EN_SLA", label: "En SLA" },
];

// Transfer-aware reservation state (sale line linked to its Bodega 11 transfers).
export const RESERVA_META = {
  RESERVADO_VENTA: { label: "Reservado", bg: "#D1FAE5", text: "#065F46", border: "#34D399" },
  EN_BODEGA: { label: "En Bodega 11", bg: "#EFF6FF", text: "#1E3A8A", border: "#93C5FD" },
  TRANSFER_PENDIENTE: { label: "Transfer pend.", bg: "#FEF3C7", text: "#92400E", border: "#FBBF24" },
  SIN_TRANSFER: { label: "Sin transfer", bg: "#F1F5F9", text: "#475569", border: "#CBD5E1" },
};

export function reservaMeta(code) {
  return RESERVA_META[code] || null;
}

export const RESERVA_OPTIONS = [
  { value: "RESERVADO_VENTA", label: "Reservado en venta" },
  { value: "EN_BODEGA", label: "En Bodega 11" },
  { value: "TRANSFER_PENDIENTE", label: "Transfer pendiente" },
  { value: "SIN_TRANSFER", label: "Sin transfer" },
];
